import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../constants/server.constant';
import { getLocalTime, getFullRegionDetail } from '../utility/utility';
import Axios from 'axios';

export const ImageService = {
    getAllImageDetails,
    getAllImageDetailsByType,
    deleteImageById,
    downloadImageById,
    getAllImageDetailsById,
    deleteImageByIdAndRegion,
    uploadImage,
    uploadImageBinaryData,
    editImage,
    importImageViaUrl,
    getImageById,
    uploadImageInclude,
    uploadBinaryImageLocal,
    copyImageToReg,
    getCopyImages,
    taskFailureStatus,
    delQueuedImages
};

function getUserId() {
    return localStorage.getItem('userId');
}
function requestOptions(methodType) {
    return {
        method: methodType,
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*',
        },
        withCredentials: true,
        credentials: "same-origin"
    };
}
function requestOptionsforFile(methodType) {
    return {
        method: methodType,
        headers: {
            'Accept': '*/*',
        },
        withCredentials: true,
        credentials: "same-origin"
    };
}


async function getAllImageDetailsById() {
    return await axiosInstance.get("/images/list/" + getUserId(), axiosRequestWithAuth)
        .then(response => {
            let resp = response.data;
            let images = [];
            let region = [];
            let arr = [];
            let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
            for(var key of Object.keys(resp)) {
                region.push(key);

                let imagelist = resp[key];
                let fullRegion = getFullRegionDetail(fullRegionList, key);
                imagelist.forEach(image => {

                    let d = new Date(image.created_at);
                    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ', ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });

                    images.push({
                        id: image.id,
                        name: image.name,
                        size: image.size,
                        created: createdDate,
                        regionname: key,
                        type: image.image_type,
                        status: image.status,
                        min_disk: image.min_disk,
                        image_type: image.image_type,
                        image_state: image.image_state,
                        min_ram: image.min_ram,
                        fullRegion: fullRegion
                    });

                });
            }

            arr.push(images);
            arr.push(region);
            return arr;
        })
        .catch((err) => {

            return false;
        });
}


async function getAllImageDetails(regionUrl) {

    let transformedFlavor = {
        distributionImages: [],
        images: [],
        applicationStack: []
    };
    return await axiosInstance.get('/images/' + getUserId() + '?region=' + regionUrl, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            if(data.images && data.images.length > 0) {
                data.images.forEach(flavor => {
                    let flavorName = flavor.name.split("-");
                    flavor.distribution = flavorName[0];
                    flavor.version = flavorName[1];
                    flavor.instructionSet = flavorName[2];
                    if(flavor.visibility === 'public' && flavor.tags && flavor.tags.length > 0) {
                        if(flavor.tags[0] === 'x86_64') {
                            transformedFlavor.distributionImages.push(flavor);
                        } else if(flavor.tags[0] === 'application_stack') {
                            transformedFlavor.applicationStack.push(flavor);
                        }
                    } else if(flavor.visibility === 'private') {
                        transformedFlavor.images.push(flavor);
                    }
                });
                return transformedFlavor;
            }
        }).catch(function (error) {
            return transformedFlavor;
        });
}

async function getAllImageDetailsByType(regionUrl, instanceId, type) {
    return await axiosInstance.get('/images/' + instanceId + '/' + type + '/' + getUserId() + '?region=' + regionUrl, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            if(data !== undefined) {
                let images = data.images;
                if(images !== undefined && images.length > 0) {
                    images.forEach(item => {
                        item.created_at = getLocalTime(item.created_at);
                    });
                }
            }
            return resp.data;
        }).catch(function (error) {
            return [];
        });
}

async function getImageById(region, imageId) {
    return await axiosInstance.get('/images/' + imageId + '/' + getUserId() + '?region=' + region, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            return resp.data;
        }).catch(function (error) {
            return [];
        });
}

async function deleteImageById(regionUrl, imageId) {
    return await axiosInstance.delete('/images/' + getUserId() + '/' + imageId + '/' + '?region=' + regionUrl, axiosRequestWithAuth)
        .then(resp => {
            return true;
        }).catch(function (error) {
            return false;
        });
}

function downloadImageById(regionUrl, imageId, name) {
    return API_HOST + '/images/download/' + getUserId() + '/' + imageId + '?region=' + regionUrl + '&name=' + name;

}

async function deleteImageByIdAndRegion(region, imageId) {
    return await axiosInstance.delete('/images/' + imageId + '/' + region + '/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return true;
        }).catch(function (error) {
            return false;
        });
}

async function uploadImage(region, requestBody) {
    //let requOptions = requestOptions('POST');
    //requOptions.body = JSON.stringify(requestBody);
    return await axiosInstance.post(API_HOST + '/images/' + region + '/' + getUserId(), JSON.stringify(requestBody), axiosRequestWithAuth)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return false;
        });
}

async function uploadImageInclude(region, requestBody) {
    return await axiosInstance.post(API_HOST + '/images/' + region + '/' + getUserId() + '?isTokenInclude=true', JSON.stringify(requestBody), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function uploadImageBinaryData(region, files, options, requestBody) {
    const formData = new FormData();
    formData.append("file", files);
    formData.append("requestBody", JSON.stringify(requestBody));
    let axiosReq = axiosRequestWithAuth;
    axiosReq.onUploadProgress = options.onUploadProgress;
    axiosReq.cancelToken = options.cancelToken;
    return await axiosInstance.post(API_HOST + '/images/upload/' + region + '/' + getUserId(), formData, axiosReq)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return false;
        });
}

async function uploadBinaryImageLocal(url, token, files, options) {

    const axios = Axios.create({});
    let axiosRequestUpload = {
        headers: {
            'Content-Type': 'application/octet-stream',
            'X-Auth-Token': token,
        }
    };
    axiosRequestUpload.onUploadProgress = options.onUploadProgress;
    axiosRequestUpload.cancelToken = options.cancelToken;
    return await axios.put(url, files, axiosRequestUpload)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return false;
        });
}

async function importImageViaUrl(region, imageId, url, imageName) {
    const formData = new FormData();
    formData.append("imageurl", url);

    return await axiosInstance.post(API_HOST + '/images/url/' + region + "/" + imageId + "/" + imageName + '/' + getUserId(), formData, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return false;
        });
}


async function editImage(region, imageId, imageName) {
    let requOptions = axiosRequestWithAuth;

    return await axiosInstance.post(API_HOST + '/images/edit/' + imageId + '/' + region + '/' + getUserId() + '?name=' + imageName, {}, requOptions)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return false;
        });
}

async function copyImageToReg(imageId, fromRegion, toRegion, name) {
    return await axiosInstance.post(API_HOST + '/images/copy/' + imageId + "/" + fromRegion + "/" + toRegion + "/" + getUserId() + "?name=" + name, {}, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getCopyImages() {
    return await axiosInstance.get(API_HOST + '/images/copy/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function taskFailureStatus(reqbody) {
    return await axiosInstance.post(API_HOST + '/images/failure-status/' + getUserId(), reqbody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}


async function delQueuedImages(region) {
    return await axiosInstance.delete(API_HOST + '/images/queued/' + getUserId() + "?region=" + region, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        if(!response.ok) {
            throw Error(response.statusText);
        }
        if(text === '') {
            return text;
        }
        return JSON.parse(text);
    });
}

export default ImageService;